import React, { Component } from 'react';

import { findVendor } from '../../vendor';
import { AddDomains } from './AddDomains';
import { FreeRegistration } from './FreeRegistration';
import { LicenseKey } from './LicenseKey';
import { UpgradePrompt } from './UpgradePrompt';
import { PaidPlanRequired } from './PaidPlanRequired';
import { Message } from '../common/Message';

// The Details step (step 2 in issue #71 Phase 1). The License Key box
// is mandatory and sits at the top. A customer with no key registers
// for a free key inside the configurator (step 2b) or follows the
// pricing page link for a paid plan. The old optional details section
// and the "Free product is enough for me" box are gone. Contact and
// marketing capture now live in the free registration.
export class Details extends Component {
    displayName = Details.name;

    constructor(props) {
        super(props);

        // Which route the customer is on. The free route from the splash
        // lands on sign-up; everyone else sees only the two buttons
        // until they choose, so the page starts with one question.
        // registered tracks a completed sign-up, which reveals the
        // License Key box whether or not the key arrived automatically.
        this.state = {
            mode: props.freeIntent ? 'new' : null,
            registered: false
        };
    }

    setMode = (mode) => {
        this.setState({ mode: mode });
    }

    onRegistered = () => {
        this.setState({ registered: true });
    }

    render() {
        let selectedIds = this.props.selectedProperties.filter(
            prop => prop.startsWith("hardware.Profiles") === false);
        let paidProperties = this.props.paidProperties;
        let availableProperties = this.props.availableProperties;
        let vendors = this.props.vendors;
        let newLicenseTypes = this.props.newLicenseTypes;

        // Full property objects for the selection, used by the
        // upgrade prompt to read each property's Plans labels.
        let selectedPropertyObjects = [];
        selectedIds.forEach((id) => {
            var prop = this.props.properties.find((p) => p.Id === id);
            if (prop !== undefined) {
                selectedPropertyObjects.push(prop);
            }
        });

        let fiftyone = null;
        for (var i = 0; i < vendors.length; i++) {
            var vendor = vendors[i];
            if (vendor.name !== undefined && vendor.name.startsWith("51Degrees")) {
                fiftyone = vendor;
            }
        }
        // Fall back to a default 51Degrees vendor when the list contains no
        // 51Degrees entry (for example when all of them are filtered out as
        // disabled). Without this the license key step dereferences a null
        // vendor when rendering its icon, blanking the page.
        if (fiftyone === null) {
            fiftyone = findVendor(vendors, "51Degrees");
        }

        var requiredVendors = [];
        paidProperties.forEach((property) => {
            var vendor = findVendor(vendors, property.VendorId);
            // Case-insensitive: the cloud does not always report names in
            // the catalogue's casing (agent-signature reports them lowercase).
            var propertyName = property.Id.split('.').slice(-1)[0].toUpperCase();
            var available = availableProperties.Products[property.VendorId] &&
                availableProperties.Products[property.VendorId].Properties.find(
                    p => p.Name.toUpperCase() === propertyName);
            var newName = vendor.name === "51Degrees: Device" ||
                vendor.name === "51Degrees: Location" ?
                "51Degrees Subscription" : vendor.name;
            if (requiredVendors.find(v => v.name === newName) === undefined) {
                requiredVendors.push({ name: newName, available: available });
            }
        });

        let hasKeys = this.props.productKeys.length > 0;
        // Free registration is only offered when every selected property
        // is free. Any paid property means a free key would not cover the
        // selection, so the pricing route is shown instead.
        let allFree = this.props.paidProperties.length === 0;

        return (
            <main className="g-main" >
                <div className="g-panel g-panel--100">
                    <article className="g-info">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <h2 className="g-info__title">Enter your License Key</h2>
                                    <p className="g-info__description">
                                        Enter your License Key below, or
                                        Register to create a new License Key.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="c-key-toggle" role="group"
                                        aria-label="How will you provide your License Key?">
                                        <button type="button"
                                            className={`c-key-toggle__btn ${this.state.mode === 'existing' ? 'is-on' : ''}`}
                                            aria-pressed={this.state.mode === 'existing'}
                                            onClick={() => this.setMode('existing')}>
                                            I have a License Key
                                        </button>
                                        <button type="button"
                                            className={`c-key-toggle__btn ${this.state.mode === 'new' ? 'is-on' : ''}`}
                                            aria-pressed={this.state.mode === 'new'}
                                            onClick={() => this.setMode('new')}>
                                            Sign up for a new key
                                        </button>
                                    </div>
                                    {this.state.mode === 'existing' ||
                                        (this.state.mode === 'new' &&
                                            (hasKeys || this.state.registered)) ? (
                                        <React.Fragment>
                                            <h3 className="g-info__heading">Required: License Key</h3>
                                            <LicenseKey id={newLicenseTypes.NONE}
                                                selected={true}
                                                disabled={false}
                                                addKey={this.props.addKey}
                                                productKeys={this.props.productKeys}
                                                fiftyone={fiftyone}
                                                requiredVendors={requiredVendors}
                                                loadingLicense={this.props.loadingLicense}
                                                setLoading={this.props.setLoading}
                                            />
                                            {this.props.resourceError ? (
                                                <Message message={this.props.resourceError}
                                                    className="c-license-key__error" />
                                            ) : null}
                                        </React.Fragment>
                                    ) : null}
                                </div>
                            </div>

                            {hasKeys ? (
                                <div className="row">
                                    <div className="col-12">
                                        <UpgradePrompt
                                            plans={this.props.plans}
                                            selectedProperties={selectedPropertyObjects}
                                            productKeys={this.props.productKeys}
                                        />
                                    </div>
                                </div>
                            ) : null}

                            {/* The server refuses a selection the License
                                Key's plan does not cover (issue #75). Its
                                message names each property and the plan that
                                would cover it, so it is shown rather than a
                                generic failure. */}
                            {this.props.registerFailedMessage ? (
                                <div className="row">
                                    <div className="col-12">
                                        <Message
                                            message={this.props.registerFailedMessage}
                                            className="c-license-key__error" />
                                    </div>
                                </div>
                            ) : null}

                            {this.state.mode === 'new' ? (
                                allFree ? (
                                    <div className="row">
                                        <div className="col-12">
                                            <h3 className="g-info__heading">
                                                Sign up for a free License Key
                                            </h3>
                                            <FreeRegistration
                                                expanded={true}
                                                preselected={this.props.freeIntent}
                                                onRegistered={this.onRegistered}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-12">
                                            <PaidPlanRequired
                                                plans={this.props.plans}
                                                selectedProperties={selectedPropertyObjects}
                                                requiredVendors={requiredVendors}
                                            />
                                        </div>
                                    </div>
                                )
                            ) : null}

                            {this.state.mode !== null ? (
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="g-info__heading">
                                            Restrict to your website domains (optional)
                                        </h3>
                                        <AddDomains domains={this.props.domains}
                                            updateDomains={this.props.updateDomains} />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </article>
                </div>
            </main>
        );
    }
}
